import StateRepository from '../domain/stateRepository';
import httpService from '../../../services/httpService';

export default class RemoteStateRepository extends StateRepository {
  async getAll() {
    const { data } = await httpService.get('/entidades')
    return data
  }
}
